// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "p {\n  margin-block-start: 0;\n  margin-block-end: 0;\n}\n", "",{"version":3,"sources":["webpack://./node_modules/@tencent/dz-runtime/es/styles/reset.less"],"names":[],"mappings":"AACA;EACE,qBAAA;EACA,mBAAA;AAAF","sourcesContent":["\np {\n  margin-block-start: 0;\n  margin-block-end: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
